import Main from '@/main.vue';
import MultistageLayout from '@/components/multistageLayout';
const routeMap = {
  // 应用管理一级菜单
  PermissionManagementSystem: {
    component: Main,
    icon: 'ios-menu'
  },
  bpmManageFun: {
    component: Main,
    icon: 'ios-menu'
  },
  // 应用管理s
  appList: {
    component: () => import('@views/tab/applicationManage/applicationManage.vue'),
    icon: 'ios-paper-outline'
  },
  // 菜单管理
  funcMenuList: {
    component: () => import('@views/tab/menuManage/menuManage.vue'),
    icon: 'ios-paper-outline'
  },
  // 角色管理
  roleList: {
    component: () => import('@views/tab/characterManage/characterManage.vue'),
    icon: 'ios-paper-outline'
  },
  // 人物管理
  usersList: {
    component: () => import('@views/tab/userManage/userManage.vue'),
    icon: 'ios-paper-outline'
  },
  bpmManage: {
    component: Main,
    icon: 'ios-menu'
  },
  // 审批模版组
  tplGroupManage: {
    component: () => import('@views/bpm/tempGroupManage/index.vue'),
    icon: 'ios-paper-outline'
  },
  // 审批模版管理
  tplApprovalManage: {
    component: () => import('@views/bpm/tempApprovalManage/index.vue'),
    icon: 'ios-paper-outline'
  },
  // 审批模版
  tplApproval: {
    component: () => import('@views/bpm/tempApproval/index.vue'),
    icon: 'ios-paper-outline',
    hideInMenu: true
  },
  // 数据管理列表
  dataManage: {
    component: () => import('@views/bpm/dataManage/index.vue'),
    icon: 'ios-paper-outline'
  },
  // 审批列表
  approvalTask: {
    component: () => import('@views/bpm/approvalTask/approvalTaskList/index.vue'),
    icon: 'ios-paper-outline'
  },
  // 审批详情
  approvalDetail: {
    component: () => import('@views/bpm/approvalTask/approvalDetail/index.vue'),
    icon: 'ios-paper-outline'
  },
  // 发起审批列表
  launchApproval: {
    component: () => import('@views/bpm/launchApproval/launchApprovalList/index.vue'),
    icon: 'ios-paper-outline'
  },
  // 发起审批详情
  launchApprovalDetail: {
    component: () => import('@views/bpm/launchApproval/launchApprovalDetail/index.vue'),
    icon: 'ios-paper-outline'
  },
  // 提交成功中转页
  successTransfer: {
    component: () => import('@views/bpm/launchApproval/successTransfer/index.vue'),
    icon: 'ios-paper-outline'
  }
  // // 测试
  // yiji: {
  //   component: Main,
  //   icon: 'ios-paper-outline'
  // },
  // yiji1: {
  //   component: MultistageLayout,
  //   icon: 'ios-paper-outline',
  //   meta: {
  //     isMultistage: true,
  //     currentComponent: () => import('@views/bpm/approvalTask/approvalTaskList/index.vue')
  //   }
  // },
  // ceshicaidanxiaquanxian: {
  //   component: () => import('@views/bpm/approvalTask/approvalDetail/index.vue')
  // }
};
export { routeMap };
